module.exports = __webpack_public_path__ + "static/media/education.e61ce491.jpg";